(function () {
  var STORAGE_KEY = 'shop_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCount();
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function addToWishlist(id, handle, variantId) {
    var list = getWishlist();

    if (!isInWishlist(id)) {
      list.push({
        id: id,
        handle: handle,
        variantId: variantId
      });

      saveWishlist(list);
    }
  }

  function removeFromWishlist(id) {
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });

    saveWishlist(list);
  }

  function updateCount() {
    var count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncButtonState(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = isInWishlist(id);

    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButtonState);
  }

  // document.addEventListener('click', function (e) {
  //   var btn = e.target.closest('[data-wishlist-toggle]');
  //   if (!btn) return;

  //   e.preventDefault();

  //   var id = btn.getAttribute('data-product-id');
  //   var handle = btn.getAttribute('data-product-handle');
  //   var variantId = btn.getAttribute('data-variant-id');

  //   if (isInWishlist(id)) {
  //     removeFromWishlist(id);
  //   } else {
  //     addToWishlist(id, handle, variantId);
  //   }

  //   document
  //     .querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]')
  //     .forEach(syncButtonState);
  // });
document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault();

    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    var variantId = btn.getAttribute('data-variant-id');

    if (isInWishlist(id)) {
      removeFromWishlist(id);

      var grid = document.getElementById('wishlist-products-grid');
      if (grid) {
        var card = btn.closest('product-card');
        if (card) {
          card.remove();
          if (!grid.children.length) {
            var emptyState = document.getElementById('wishlist-empty-state');
            if (emptyState) emptyState.hidden = false;
          }
        }
      }
    } else {
      addToWishlist(id, handle, variantId);
    }

    document
      .querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]')
      .forEach(syncButtonState);
  });
  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();
    updateCount();
  });

  document.addEventListener('shopify:section:load', function () {
    syncAllButtons();
    updateCount();
  });

  window.Wishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    isInWishlist: isInWishlist
  };
})();